import { BlipTheme } from '@/components/Blip/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Blip = GenericSlot({ as: 'div', theme: BlipTheme });
